import script from "./MsgCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgCenter.vue?vue&type=script&setup=true&lang=js"

import "./MsgCenter.vue?vue&type=style&index=0&id=6a09ed57&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a09ed57"]])

export default __exports__